module.exports = __webpack_public_path__ + "static/media/PH3800__007_Boss.b3b087cb.mp3";